import Alert from '@mui/material/Alert';
import MLink from '@mui/material/Link';
import { useAppContext } from '../contexts/app';

type Props = {
  returnTo?: string;
  action?: string;
  className?: string;
  compact?: boolean;
};

const LoginRequiredNotice = ({ returnTo, action = 'use this feature', className, compact = false }: Props) => {
  const { login } = useAppContext();

  return (
    <Alert severity="info" className={className} sx={{ my: compact ? 2 : 4 }}>
      <MLink
        href="/login"
        onClick={(e) => {
          e.preventDefault();
          login(returnTo);
        }}
      >
        Log in
      </MLink>
      {' '}to {action}.
    </Alert>
  );
};

export default LoginRequiredNotice;
